/**
 * 파일명 : com0104m.jsx
 * 설명 : 게시글등록
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 *     
 */


 /************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0104mAction } from '../../../redux/slice/com/com0104m_slice';
import { IAttachFileItemState, IBoardDcdItemState, IRecipientItemState } from '../../../redux/models/com/com0104m_model';

/* CSS */

/* AntD */
import { Input, Layout, Row, Space, Button, Descriptions, Col, Upload, Switch, Select, Typography } from 'antd';
import { UploadOutlined, MailOutlined, DeleteOutlined } from '@ant-design/icons';

// Editor
import { Editor } from '@tinymce/tinymce-react';

/* 업무 */
import { IPropsCom0104M } from 'redux/models/com/com0104m_model';
import * as common from 'libs/common';
import * as commonProxy from 'libs/CommonProxy';
import * as commonDate from 'libs/commonDate';
import parse from 'html-react-parser';


/************************************************
 * 전역변수 선언영억
 ************************************************/

const Com0104m = (props:IPropsCom0104M) => {
    let tmp = 0;
    const editorHeightDiff = 400;
    
    /* State / Reducer */
    const dispatch = useAppDispatch();
    const authBoardItems     = useAppSelector((state) => state.Frame.authBoardItems);
    const attachFileItems    = useAppSelector((state) => state.Com0104m.attachFileItems);
    const fileList           = useAppSelector((state) => state.Com0104m.fileList);
    const recipientList      = useAppSelector((state) => state.Com0104m.recipientList);
    const boardItems         = useAppSelector((state) => state.Com0104m.boardItems);
    const boardDcdList       = useAppSelector((state) => state.Com0104m.boardDcdList);
    const [isEditMode    , setIsEditMode]     = React.useState(false);
    const editorRef = React.useRef(null);

    const [editorHeight, setEditorHeight] = React.useState<number>(window.innerHeight - editorHeightDiff); // 기본 화면 높이에서 400px을 빼기
    const [editorKey, setEditorKey] = React.useState<number>(0);

    /* AntD */
    const { Content }  = Layout;
    const { Text } = Typography;

    /* Table Columns */
    const columnsAttachFiles = React.useCallback(() => {
        const arr:any = [
            {
                key: 'action',
                render : (record:IAttachFileItemState) =>{
                    if(record.id > 0){
                        return <Button name='btn_showDetail' className='link-button' type='link' size='small' onClick={() => common.downloadFile(record.id)}>{record.orginFileNm}</Button>
                    }else{
                        return record.orginFileNm;
                    }
                },
                align: 'left',
                width: '80px',
            },
            {
                key: 'orginFileNm',
                render : (record:IAttachFileItemState) => {
                    if (record.id < 1 || boardItems.id < 1 || isEditMode) {
                        return <Button name='btn_del' icon={<DeleteOutlined/>} className='link-button' size='small' onClick={() => {
                            dispatch(Com0104mAction.removeFileList(record));
                            dispatch(Com0104mAction.removeAttachFileItems(record));
                        }}></Button>
                    } else {
                        return null
                    }
                },
                align: 'center',
                width: '5%',
            },
        ]
        return arr;
    }, [attachFileItems, isEditMode]);

    const columnsRecipientList = React.useCallback(() => {
        const arr:any = [
            {
                dataIndex: 'userNm',
                key: 'userNm',
                align: 'center',
                width: '10%',
            },
            {
                dataIndex: 'postNm',
                key: 'postNm',
                align: 'center',
                width: '20%',
            },
            {
                dataIndex: 'chkYn',
                key: 'chkYn',
                align: 'center',
                width: '15%',
                render: (_:string, record:IRecipientItemState) => (
                    record.chkYn === 'Y' ? commonDate.maskDate(record.lstChgDtm, 'YYYY-MM-DD') : '안읽음'
                ),
            },
        ]
        return arr;
    }, [recipientList, isEditMode]);

    const fn_Search = () => {
        fn_Reset();
        if (props && props.id > 0) {
            /* 변수선언 및 셋팅 영역 */
            // 입력파라미터
            const requestData = {
                id : props.id,
            };
    
            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMR0006',
                success : (responseData:any) => {
                    const boardItems      = responseData.boardItems[0];
                    const attachFileItems = responseData.attachFileItems;
                    const boardChkItems   = responseData.boardChkItems;
    
                    setIsEditMode(false);
                    dispatch(Com0104mAction.setBoardItems(boardItems));
                    dispatch(Com0104mAction.setAttachFileItems(attachFileItems));
                    dispatch(Com0104mAction.setRecipientList(boardChkItems));
                },
            });
        } else {
            setIsEditMode(true);
        }
    }

    React.useEffect(() => {
        setBoardDcdList();
        fn_Search();

        const handleResize = () => {
            setEditorHeight(window.innerHeight - editorHeightDiff); // 화면 크기 변경 시 에디터 높이 업데이트

            let tmpKey = ++tmp;
            tmp = tmpKey;
            setEditorKey(tmpKey);
        };

      
        window.addEventListener('resize', handleResize);
            return () => {
            window.removeEventListener('resize', handleResize); // cleanup
        };
    }, []);

    const setBoardDcdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IBoardDcdItemState[]) => {
                let arrOptions:IBoardDcdItemState[] = [];
                let authArr:any = [];

                datas.forEach((item:IBoardDcdItemState) => {
                    for (let key in authBoardItems) {
                        if (authBoardItems[key].upperMenuId === 'MCOM2021005' && authBoardItems[key].relVal) {
                            authArr.push(authBoardItems[key].relVal);
                        }
                    } 

                    if (authArr.includes(item.cd)) {
                        arrOptions.push({
                            label: item.cdNm,
                            value: item.cd
                        });
                    }
                });

                dispatch(Com0104mAction.setBoardDcdList(arrOptions));
            }

        };
        common.getComCodeList('017', option);
    }

    /** 
    * 기능 : antd dummy 업로드 흐름 관리
    * param : onSuccess
    * return : none
    */
     const dummyRequest = ({ file, onSuccess }:any) => {  	// 업로드 흐름 관리
        setTimeout(() => {
            if (fileList.filter((e:any) => {
                return e.name === file.name;
            }).length < 1) {
                onSuccess('ok');
            }
        }, 0);
    };

    /**
     * 기능 : 파일들을 Back으로 보내 업로드 한다.
     * param :
     * return : None
     */
     const requestUploadFiles = (options:any) => {
        common.uploadFile(fileList, {
            sourceDcd: '01',
            sourceId: 0,
            success: (response:any) => {
                if(typeof options.callback === 'function'){
                    options.callback(response);
                }
            },
        });
    }

    /**
     * 기능 : 선택한 파일중 done인 파일을 fileList에 추가한다.
     * param :
     * return : None
     */
     const selectFile_onChange = (info:any) => {
        switch (info.file.status) {
            case 'done':
                const grdFile = { fileNm : info.file.originFileObj.name, orginFileNm : info.file.originFileObj.name };
                dispatch(Com0104mAction.addFileList(info.file.originFileObj));
                dispatch(Com0104mAction.addAttachFileItems(grdFile));
                break;

            default:
                break;
        }
    }

    /**
     * 기능 : upload버튼의 기능 할당
     * param :
     * return : None
     */
    /* File Upload Options */
    const uploadProps = {
        onChange: selectFile_onChange,
        multiple: true,                  // 파일 다중 선택
        showUploadList: false, 		     // 업로드된 파일 리스트 보기
    };

    /**
     * 기능 : 초기화 이벤트 선언
     * param : 
     */
    const fn_Reset = () => {
        dispatch(Com0104mAction.initState());
        setIsEditMode(true);
    };

     /**
     * 기능 : 저장 이벤트 선언
     * param : 
     */
    const fn_SaveBoard = (boardStCd:string) => {
        const save = (boardStCd:string, fileItems:IAttachFileItemState[]) => {
            /* 변수선언 및 셋팅 영역 */
            let   requestData;
            if (fileItems) {
                const arrAttachFileItems: any[] = attachFileItems.filter((item:IAttachFileItemState) => {
                    return fileItems.filter((file:IAttachFileItemState) => {
                        return file.orginFileNm === item.orginFileNm;
                    }).length < 1;
                });
                requestData = { ...boardItems, fileItems: [...arrAttachFileItems, ...fileItems], boardStCd : boardStCd, boardChkItems :recipientList };
            } else {
                requestData = { ...boardItems, fileItems: attachFileItems, boardStCd : boardStCd, boardChkItems :recipientList };
            }
            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMS0002',
                success: (responseData:any) => {
                    setIsEditMode(false);
                    dispatch(Com0104mAction.setBoardItems(responseData.boardItems));
                    dispatch(Com0104mAction.setAttachFileItems(responseData.attachFileItems));

                    const param = {
                        title : '위드정보 확인',
                        contents: '정상적으로 처리되었습니다.',
                        accept: () => {
                            if(boardStCd === 'D'){
                                fn_Reset();
                            }
                        }
                    };

                    common.openAlert(param);
                },
            });
        }
        
        if (fileList && fileList.length > 0) {
            requestUploadFiles({
                callback : (data:any) => {
                    save(boardStCd, data.fileItems);
                }
            });
        } else {
            save(boardStCd, null);
        }

    };   

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
     const onClick = async (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnReset': {
                fn_Reset();
                break;
            }
            // 목록보기
            case 'btnList': {
                // const param = {
                //     menuId : 'MCOM2021006',

                // };
                const param = {
                    menuId : props.opener ? props.opener : 'MCOM2021006',
                };
                common.openPage(param);
                break;
            }
            case 'btnSave': {
                if (!boardItems.boardDcd || !boardItems.title) {
                    const param = {
                        title : '위드정보 확인',
                        contents: (!boardItems.boardDcd ? '[카테고리]' : '[제목]') + ' 은(는) 필수 입력항목입니다.',
                        accept: () => {
                            return;
                        }
                    };
                    common.openInfo(param);
                } else {
                    const param = {
                        title : '위드정보 확인',
                        contents: '게시글을 저장하시겠습니까?',
                        accept: () => {
                            fn_SaveBoard('I');
                        }
                    };
                    common.openConfirm(param);
                }

                break;
            }
            case 'btnDelete': {
                const param = {
                    title : '위드정보 확인',
                    contents: '게시글을 삭제하시겠습니까?',
                    accept: () => {
                        fn_SaveBoard('D');
                    }
                };

                common.openConfirm(param);
                
                break;
            }

            case 'btnRecipient': {
                const accept = (data:[]) => {
                    if (data && data.length > 0) {
                        dispatch(Com0104mAction.setRecipientList(data));
                    } else {
                        dispatch(Com0104mAction.setRecipientList([]));
                    }
                }
                const params:any = {};
                params.title = '수신직원 선택';
                params.popupId = 'com0103p';
                params.accept = accept;
                params.width = 1350
                params.props = {dataList : recipientList};
                common.openPopup(params);
                break;
            }

            case "btn_open_files": {
                const deleteFile = (record:IAttachFileItemState, _rowIndex:number) => {
                    dispatch(Com0104mAction.removeFileList(record));
                    dispatch(Com0104mAction.removeAttachFileItems(record));
                }
                
                const params:any = { popupId: 'com9999p', title: '첨부파일보기', width : '100%' };
                const _props:any = {};

                _props.id = 'tblFiles';
                _props.size = 'small';
                _props.columns = columnsAttachFiles();
                _props.dataSource = attachFileItems;
                _props.rowKey = 'orginFileNm';
                _props.showHeader = false;
                _props.onRow = deleteFile;
                params.props = _props;
                common.openPopup(params);
                break;
            }

            case "btn_open_recipient": {
                const params:any = { popupId: 'com9999p', title: '수신직원보기', width : '100%' };
                const _props:any = {};

                _props.id = 'tblFiles';
                _props.size = 'small';
                _props.columns = columnsRecipientList();
                _props.dataSource = recipientList;
                _props.rowKey = 'empNo';
                _props.showHeader = false;
                params.props = _props;
                common.openPopup(params);
                break;
            }
            default:
        }
    };

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Row>
                    <Col flex='auto' style={{width:'100%'}}>
                        <Descriptions bordered size='small'>
                            <Descriptions.Item label='작성자' labelStyle={{width:'150px'}}>{boardItems.rgstUserNm ? boardItems.rgstUserNm : common.getUserNm()}</Descriptions.Item>
                            <Descriptions.Item label='* 카테고리' labelStyle={{width:'150px'}} style={{width:'200px'}}>
                                <Select
                                    size='small'
                                    defaultValue=''
                                    style={{width: 200}}
                                    options={boardDcdList}
                                    onChange={val => {dispatch(Com0104mAction.setBoardItems({...boardItems, boardDcd: val}))}}
                                    value={boardItems.boardDcd}

                                    // ReadOnly 적용
                                    {...common.getReadonlySelectboxProps(!isEditMode)}
                                ></Select>
                            </Descriptions.Item>
                            <Descriptions.Item label='* 제목'>
                                <Input
                                    size='small'
                                    id='inputTitle' 
                                    name='title'
                                    value={boardItems.title} 
                                    onChange={ e => dispatch(Com0104mAction.setBoardItems({...boardItems, title: e.currentTarget.value}))}
                                    readOnly={!isEditMode}
                                />
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Row>
                    <Col style={{width:'50%'}}>
                        <Space size='small' align='start'>
                            <Col style={{marginTop:5}}>
                                <Upload
                                    {...uploadProps}
                                    id='btnUpload'
                                    name='btnUpload'
                                    customRequest={dummyRequest}
                                    disabled={!isEditMode}
                                    >
                                        {isEditMode || boardItems.id < 1 ? <Button size='small' icon={<UploadOutlined/>}/> : null}
                                </Upload>
                            </Col>
                            <Col style={{marginTop:5}}>
                                {attachFileItems && attachFileItems.length > 0 ?
                                <Button name="btn_open_files" size="small" className="link-button" type="link" onClick={onClick}><Text strong style={{fontSize:'8pt', color:'blue'}}>{'첨부파일 : ' + attachFileItems[0].orginFileNm + (attachFileItems.length > 1 ? ' 외 ' + (attachFileItems.length - 1) + '개' : '')}</Text></Button>
                                : null}
                            </Col>
                        </Space>
                    </Col>
                </Row>
                <Row>
                    <Col style={{width:'50%'}}>
                        <Space size='small' align='start'>
                            {isEditMode || boardItems.id < 1 ?
                            <Col style={{marginTop:5}}>
                                <Button 
                                    size='small'
                                    name='btnRecipient'
                                    className='background-color-default-button'
                                    onClick={onClick}
                                    disabled={!isEditMode}
                                    icon={<MailOutlined/>}/>
                            </Col> : null}
                            <Col style={{marginTop:5}}>
                                {recipientList && recipientList.length > 0 ?
                                <Button name="btn_open_recipient" size="small" className="link-button" type="link" onClick={onClick}><Text strong style={{fontSize:'8pt', color:'blue'}}>{'수신자 : ' + recipientList[0].userNm + (recipientList.length > 1 ? ' 외 ' + (recipientList.length - 1) + '명' : '')}</Text></Button>
                                : null}
                            </Col>
                            {isEditMode && boardItems.id > 0 ?
                            <Col style={{marginTop:5}}>
                                <Switch id='switchRecYn'
                                    checkedChildren='수정시재발송'
                                    unCheckedChildren='수정시미발송' 
                                    style={{width:110, color:'black'}}
                                    disabled={!isEditMode} 
                                    onChange={(isChecked) => {
                                        dispatch(Com0104mAction.setBoardItems({...boardItems, switchRecYn: isChecked}));
                                    }}
                                />
                            </Col> : null}
                        </Space>
                    </Col>
                </Row>
                <Row style={{marginTop: 10 }}>
                    <Col style={{width:'100%', border: '2px solid #007bff', borderRadius: '4px', padding: '2px'}}>
                        {!isEditMode ?
                        <div key={editorKey} style={{ height: editorHeight, display: 'flex', flexDirection: 'column', width : '100%', flex: '1 1 auto', overflowY: 'auto' }}>{parse(boardItems.cntnt)}</div> :
                        <Editor
                            key={editorKey}
                            id='editorBoard'
                            apiKey={common.editorKey}
                            onInit={(_, editor) => {
                                editorRef.current = editor;
                            }}
                            value={boardItems.cntnt}
                            init={{
                                mobile: {
                                    toolbar: ['fontfamily fontsize', 'bold underline backcolor table', 'alignleft aligncenter alignright alignjustify removeformat']
                                },
                                width: '100%',
                                autoresize_bottom_margin: 20,
                                min_height: 200,            // 에디터 옵션 최소 높이
                                autoresize_min_height: 200, // autoresize 시 최소 높이 유지
                                inline: true,
                                toolbar_mode: 'sliding',
                                resize:false,
                                language:'ko_KR',
                                height: editorHeight,
                                menubar: false,
                                readOnly: false,
                                plugins: [
                                    'advlist','autolink','autoresize',
                                    'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks',
                                    'fullscreen','insertdatetime','table'
                                    ],
                                content_style: `
                                    html, body { 
                                        min-height: 200px !important;
                                        font-family:굴림;
                                        font-size:12pt;
                                        max-width: 100%;
                                        word-wrap: break-word;
                                        overflow-wrap: break-word;
                                    }
                                    .tox .tox-toolbar {
                                        min-height: 30px !important;  /* 툴바 높이 */
                                        height: 30px !important;
                                    }
                                    .tox .tox-toolbar__group {
                                        height: 30px !important;  /* 버튼 그룹 높이 */
                                    }
                                    .tox .tox-toolbar__button {
                                        font-size: 10px !important;  /* 버튼 내 텍스트 크기 */
                                        height: 30px !important;     /* 버튼 높이 */
                                        width: 30px !important;      /* 버튼 너비 */
                                    }
                                    .tox .tox-toolbar__button svg {
                                        width: 20px !important;  /* 아이콘 크기 */
                                        height: 20px !important;
                                    }
                                    .mce-content-body {
                                        min-height: 200px !important;
                                    }
                                    pre {
                                        white-space: pre-wrap;
                                        word-break: break-word;
                                    }
                                    table {
                                        width: 100% !important;
                                        table-layout: auto;
                                        word-break: break-word;
                                    }
                                    img {
                                        max-width: 100%;
                                        height: auto;
                                    }
                                `,
                                font_formats:'본고딕=Noto sans KR;돋움=Dotum;돋움체=DotumChe;굴림=Gulim;굴림체=GulimChe;바탕=Batang;바탕체=BatangChe;궁서=Gungsuh;궁서체=GungsuhChe;새굴림=New Gulim;맑은 고딕=Malgun Gothic;나눔 고딕=Nanum Gothic;나눔 명조=Nanum Myoungjo'
                            }}
                            onEditorChange={
                                () => {
                                    dispatch(Com0104mAction.setBoardItems({...boardItems, cntnt: editorRef.current.getContent()}));
                                }
                            }
                        />
                        }
                    </Col>
                </Row>
                <Row justify='space-around' style={{marginTop: 15 }}>
                    <Col style={{ marginRight: 15 }}>
                        <Space size='small'>
                            <Button
                                size='small'
                                name='btnReset'
                                className='background-color-default-button'
                                onClick={fn_Reset}
                                >
                                초기화
                            </Button>
                            <Button
                                size='small'
                                name='btnList'
                                className='background-color-default-button'
                                onClick={onClick}
                                >
                                목록보기
                            </Button>
                            {common.getEmpNo() === boardItems.rgstEmpNo ?
                            <>
                            {!isEditMode ?
                            <>
                            <Button
                                size='small'
                                name='btnEdit'
                                className='background-color-default-button'
                                onClick={() => {
                                    setIsEditMode(true);
                                }}
                                >
                                수정
                            </Button>
                            <Button
                                size='small'
                                name='btnDelete'
                                className='background-color-default-button'
                                onClick={(onClick)}
                                >
                                삭제
                            </Button>
                            </>
                            : null}
                            </>
                            : null}
                            {boardItems.id === 0 || isEditMode ?
                            <Button
                                size='small'
                                name='btnSave'
                                className='background-color-primary-button'
                                onClick={onClick}
                            >
                                저장
                            </Button>
                            : null}
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0104m;